;(function() {
  'use strict'

  Service.$inject = ["$http", "api", "glDialog", "configService", "glAuthService", "userService", "ProjectTracker"];
  angular.module('app.core').service('projectTrackerService', Service)

  /* @ngInject */
  function Service(
    $http,
    api,
    glDialog,
    configService,
    glAuthService,
    userService,
    ProjectTracker
  ) {
    var self = this

    self.getByProject = getByProject
    self.save = save
    self.getFileHtml = getFileHtml
    self.showEditor = showEditor

    function getByProject(projectId) {
      return api.projectTrackers
        .get({ projectId: projectId })
        .then(function(resp) {
          return _.map(resp, function(data) {
            return new ProjectTracker().deserialize(data)
          })
        })
    }

    function save(tracker, projectId, options) {
      options = options || {}
      var isNew = tracker.isNew()
      var action = isNew ? 'create' : 'update'
      var params = {
        projectId: projectId,
        id: tracker.id,
      }
      tracker.isSaving = true
      reportUploadProgress(0)
      return api.projectTrackers[action](params, tracker.serialize(), {
        uploadEventHandlers: {
          progress: function(event) {
            reportUploadProgressEvent(event)
          },
        },
      })
        .then(function(resp) {
          if (isNew) {
            tracker.id = resp.id
          }
          tracker.updatedAt = moment()
          reportUploadProgress(100)
          return tracker
        })
        .finally(function() {
          tracker.isSaving = false
        })

      function reportUploadProgress(progress) {
        if (_.isFunction(options.onUploadProgress)) {
          options.onUploadProgress(progress)
        }
      }

      function reportUploadProgressEvent(event) {
        if (!event.lengthComputable) return
        reportUploadProgress(
          Math.min(99, Math.round((event.loaded / event.total) * 100))
        )
      }
    }

    function getFileHtml(projectId, trackerId, options) {
      options = options || {}
      var url = configService.getApiUrl(
        '/projects/',
        encodeURIComponent(projectId),
        '/trackers/',
        encodeURIComponent(trackerId),
        '/file',
        `?nocache=${Date.now()}`
      )
      var headers = { Accept: 'text/html' }
      if (glAuthService.hasCredentials()) {
        headers.Authorization = 'Bearer ' + glAuthService.getToken()
      }
      if (userService.getSubscriberId()) {
        headers['X-Subscriber-ID'] = userService.getSubscriberId()
      }
      return $http({
        method: 'GET',
        url: url,
        responseType: 'text',
        headers: headers,
        eventHandlers: {
          progress: function(event) {
            if (!event.lengthComputable) return
            if (_.isFunction(options.onDownloadProgress)) {
              options.onDownloadProgress(
                Math.min(99, Math.round((event.loaded / event.total) * 100))
              )
            }
          },
        },
      }).then(function(resp) {
        return resp.data
      })
    }

    function showEditor(tracker, projectId) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="project-tracker-editor__dialog">',
          '<project-tracker-editor ',
            'tracker="tracker" ',
            'project-id="projectId" ',
            'on-cancel="dialog.cancel()" ',
            'on-saved="dialog.close($tracker)" ',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          tracker: tracker || new ProjectTracker({ projectId: projectId }),
          projectId: projectId,
        },
      })
    }
  }
})()
